__webpack_require__.p = "https://www.nikantigolfclub.com/";